import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment,useRef} from 'react';
import MasterStamm from "../MasterStammComponent/MasterStamm";
import { useNavigate } from "react-router-dom";
import DetailsBox from "../shared/components/DetailsBox";
import {Typography,Button,Box, TextField,Grid} from "@mui/material";
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import apiRequest from '../../functions/api';
import { useMessage } from '../../context/message-context';
import InputBox from '../shared/components/InputBox';
import {pad} from "../../functions/default";
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import openFile from "../shared/functions/download";
function HRAufgabenglobal(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { accessToken,  client,} = props;
  const [open,setOpen] = useState(false);
  const [dialog,setDialog] = useState(false); 
  const [dialogpersonen,setDialogpersonen] = useState(false); 
  const [stamm,setStamm] = useState([]);
  const zeilenauswahl=useRef("");
  const spaltenauswahl=useRef("");
  const [openibox,setOpenIBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {hideMessage, showErrorMessage,showSuccessMessage} = useMessage();
  const [zuorddat,setZuordDat] = useState("");
  const [fragen,setFragen] = useState([]);
  const [iboxtitle,setIBoxTitle]=useState("");
  const [auswertung,setAuswertung] = useState([]);
  const [showauswertung,setShowAuswertung] = useState(false);
  const [options,setOptions] = useState([]);
  const [auswahl,setAuswahl]=useState("");
  const [personen,setPersonen]=useState([]);
  const [ansichtstatus, setAnsichtstatus]=useState(localStorage.getItem("HRAUFG_ANSICHT") ? localStorage.getItem("HRAUFG_ANSICHT") : "" );
  const [qualifikation, setQualifikation]=useState("");
  const [aenderung, setAenderung]=useState("");
  const [messageopen,setMessageOpen]=useState("");
  const [jahr,setJahr]=useState("2022");
  const [showjahreswechsel,setShowJahresWechsel]=useState(false);
  const [msgboxloeschen,setMsgBoxLoeschen] = useState(false);
  const [msgboxerledigen,setMsgBoxErledigen] = useState(false);
  const [nurbottons,setNurButtons] = useState("");
  const [dateibox,setDateiBox] =useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [textsuchvorgabe, setTextsuchvorgabe] = useState("offen");
  useEffect(() => {
    if (ansichtstatus==="ARBEITNEHMER" && auswahl) {
      buttonAnfrage("AN_LADEN","",auswahl)
    }
    // eslint-disable-next-line
  }, [auswahl])
const errorcB = () => {
  setIsLoading(false);
  showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
}
const handleResponse = (result) => {
  setMessageOpen(false);
}
const dateiupload = () => {
  if (!selectedFile) {
    showErrorMessage(t("Keine Datei ausgewählt"));
    return;
  }
  const payload={
    "key":zeilenauswahl.current,
  }  
  const data = new FormData();
  hideMessage();
  setIsLoading(true);
  data.append('file', selectedFile);
  data.append('payload', JSON.stringify(payload));
  console.log(selectedFile);
  const headers={
      "Authorization": "Bearer "+accessToken,
      "FileName": selectedFile.name,
      "Mandant": client, // this.props.client,
      "Program": "HRAUFG",
      "Statement": "INFODATEI_UPLOAD"
  }
  apiRequest('POST', 'upload', data, headers, anfrageCB,errorcB);    
}
const download_datei = (zeile) => {
  console.log("Dokument öffnen")
  setIsLoading(true)
  const payload={
    "mandant": client, 
    "program":"HRAUFG",
    "statement": "DOKUMENT_ANZEIGEN",
    "key":zeile,
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
    "Accept": "application/pdf"
  }
  axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
    .then((response) => {
      var fileName = "Anweisung"+".pdf";
      var contentFile = response.data;
      const mimeType = response.headers['content-type'] || 'application/pdf'
      openFile(fileName, contentFile,mimeType);
      setIsLoading(false);
    })
    .catch(function (error) {
      console.log(error.response.data)
      showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      setIsLoading(false);
    })
}
const anfrageCB = (response) => {
   setIsLoading(false);
   setOpenIBox(false);
   setDateiBox(false);
   if (response.status === 200) {
      setZuordDat("");
      if (response.data.message) {
        if (response.data.message!=="ok") {
          showSuccessMessage(response.data.message);
        }
      }
      if (response.data.stamm) {
        setStamm(response.data.stamm);
      }
      if (response.data.fragen) {
        setFragen(response.data.fragen);
        setOpenIBox(true)
      }
      if (response.data.titel) {
        setIBoxTitle(response.data.titel);
      }
      if (response.data.auswertung) {
        setAuswertung(response.data.auswertung);
        setShowAuswertung(true)
      }
      if (response.data.nurbuttons) {
        setNurButtons(response.data.nurbuttons)
      } else {
        setNurButtons("")
      }  
      if (response.data.ansichtstatus) {
        setAnsichtstatus(response.data.ansichtstatus);
        localStorage.setItem("HRAUFG_ANSICHT",response.data.ansichtstatus)
      }
      if (response.data.personen) {
        setPersonen(response.data.personen);
        setDialogpersonen(true);
        setAenderung('');
        setZuordDat(new Date().getFullYear().toString()+"-"+pad(new Date().getMonth()+1,2)+"-"+pad(new Date().getDate(),2));
      }
      if (response.data.qualibez) {
        setQualifikation(response.data.qualibez);
      }
      if (response.data.neuerkey){  
        setOpen(false);
      }
   } else {
       if (response) {
         showErrorMessage(response.data.message);
       } else {
         showErrorMessage(t("Keine Internetverbindung"));
       }
   } 
}
 
 const buttonAnfrage = (statement,button,key) => {
   setIsLoading(true);
   const payload={
     "mandant": client,
     "program": "HRAUFG",
     "statement": statement,
     "button": button,
     "key":key,
     "ansichtstatus": ansichtstatus,
     "jahr":jahr,
   }
   const headers={
     "Authorization": "Bearer "+accessToken,
   }
   apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
 }
 
 const inputBoxResult = (results) => {
   console.log("hi");
  setIsLoading(true);
  const payload={
    "mandant": client, // this.props.client,
    "program": "HRAUFG",
    "button": spaltenauswahl.current,
    "key": zeilenauswahl.current,
    "statement": "BUTTON_SPEICHERN",
    "antworten": results,
    "ansichtstatus": ansichtstatus,
  }
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
}
const buttonClick = (spaltenkey,zeilenkey) => {
  setZuordDat(new Date().getFullYear().toString()+"-"+pad(new Date().getMonth()+1,2)+"-"+pad(new Date().getDate(),2));
   switch (spaltenkey) {
        case "ZUORDNEN":
          zeilenauswahl.current=zeilenkey
          spaltenauswahl.current=spaltenkey         
          setDialog(true);
         break;
        case "NEUANLAGE":
           navigate("/interview/IV0092",{state: { austritt:"J", programm: "HRAUFG" }})
          // navigate("/WEBAGU/add")
         break;
        case "AUSWERTUNG":
         if (ansichtstatus==="ARBEITNEHMER") {
            spaltenkey="JAHRWECHSELN"  
            setAuswahl("")
            zeilenauswahl.current=zeilenkey
            spaltenauswahl.current=spaltenkey
            buttonAnfrage("BUTTON_START",spaltenkey,zeilenkey)
          }
         break;
        case "AUFGABENDETAILS":
          zeilenauswahl.current=zeilenkey
          spaltenauswahl.current=spaltenkey  
          setOpen(true)
         break;
        case "DETAILS":
          zeilenauswahl.current=zeilenkey
          spaltenauswahl.current=spaltenkey  
          setOpen(true)
         break;
        case "WECHSELN":
          zeilenauswahl.current=zeilenkey
          spaltenauswahl.current=spaltenkey  
          buttonAnfrage("BUTTON_START",spaltenkey,zeilenkey) 
          break;
       default:
         zeilenauswahl.current=zeilenkey
         spaltenauswahl.current=spaltenkey  
         buttonAnfrage("BUTTON_START",spaltenkey,zeilenkey) 
       break;
   }
}
const messageBoxLoeschenResult = (result) => {  
    if (result === 'YES') {
      setOpen(false);
      buttonAnfrage("BUTTON_START","LOESCHEN",zeilenauswahl.current);
    }
    setMsgBoxLoeschen(false) 
}
const messageBoxErledigenResult = (result) => {  
  if (result === 'YES') {
    setOpen(false);
    buttonAnfrage("BUTTON_START","ERLEDIGEN",zeilenauswahl.current);
  }
  setMsgBoxErledigen(false) 
}
const detailsClick = (button) => {  
  if (button==="LOESCHEN") {
    setMsgBoxLoeschen(true);
    return
  }
  if (button==="ERLEDIGEN") {
    setMsgBoxErledigen(true);
    return
  }
  if (button==="INFODOK") {
    download_datei(zeilenauswahl.current)
    return
  }
  if (button==="EDIT") {
    setOpen(false);
    spaltenauswahl.current=button;
    buttonAnfrage("BUTTON_START",button,zeilenauswahl.current);
    return
  }
  if (button==="EIGENSCHAFTEN") {
    setOpen(false);
    spaltenauswahl.current=button;
    buttonAnfrage("BUTTON_START",button,zeilenauswahl.current);
    return
  }
  buttonAnfrage("BUTTON_START",button,zeilenauswahl.current) 
}
const IboxButtonClick = (button,buttonkey) => {
  switch (button) {
    case "DATEI":
      setSelectedFile();
      setDateiBox(true);
    break;
    default:
      spaltenauswahl.current=button  
      buttonAnfrage("BUTTON_START",button,zeilenauswahl.current) 
    break;
  }
} 
const onChangeHandler = (event,) => {  
  setSelectedFile(event.target.files[0]);
}
const handleJahrChange = (e) => {setJahr(e.target.value)}
  return (
    <Fragment>
    <MasterStamm minbreite={500} accessToken={accessToken} client={client} pvxprogramm={"HRAUFG"} buttonClick={buttonClick} textsuchvorgabe={textsuchvorgabe} stamm={stamm} setStamm={setStamm} auswahl={auswahl} setAuswahl={setAuswahl} ansichtstatus={ansichtstatus} setAnsichtstatus={setAnsichtstatus} tablesuche={ansichtstatus==="ARBEITNEHMER"?"KEINE":""} fenstergroße={12} keineAktionen={ansichtstatus==="ARBEITNEHMER"}  StartFilter={"0"} ></MasterStamm>
   
    <MessageBox 
      open={msgboxerledigen}
      handleResponse={messageBoxErledigenResult}
      buttons="YESNO"
      text={'Sind Sie sich sicher, dass Sie die Aufgabe zum heutigen Datum erledigen wollen?"'}
      title={t("Bestätigung")}
      onClose={() => setMsgBoxErledigen(false)}
    />
    <MessageBox 
      open={msgboxloeschen}
      handleResponse={messageBoxLoeschenResult}
      buttons="YESNO"
      text={'Soll die Aufgabe wirklich gelöscht werden?"'}
      title={t("Löschbestätigung")}
      onClose={() => setMsgBoxLoeschen(false)}
    />
    <DetailsBox
      open={open}
      details={stamm?.[spaltenauswahl.current]?.[zeilenauswahl.current]}
      title={t("Detailsansicht")}
      onClose={() => setOpen(false)} 
      onBtnKlick={detailsClick}       
    />
    <ResponsiveDialog 
        title={t("Jahreswechsel")}
        open={showjahreswechsel} 
        setOpen={(o) => {setShowJahresWechsel(false)}}
      >
      <Fragment>
        <TextField label={"Für welches Jahr?"} onChange={handleJahrChange}  value={jahr} ></TextField>
      </Fragment>
     <Button color="primary" onClick={ () => setShowJahresWechsel(false)} >{t("Schließen")}</Button>
    
    </ResponsiveDialog>
    <ResponsiveDialog 
        title={t("Dateiauswahl")}
        open={dateibox} 
        setOpen={(o) => {setDateiBox(false)}}
      >
        <Box p={1}>
       <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12}>
            <Grid item xs={12}>
            <input
              color="primary"
              type="file"
              id="file-input"
              onChange={ (event) =>  onChangeHandler(event)}
              style={{display: 'none'}}
            />
            <label htmlFor="file-input" className="mr-2">
              <Button
                id="au_upload"
                variant="contained"
                component="span"
                color="primary"
                label={t("Dateiupload")}
                fullWidth
              >
                {t("Datei auswählen")}
              </Button>
            </label> 
            </Grid>
            { selectedFile && 
                <Grid item xs={12}>
                <Typography variant="body1" color="primary" align="center">
                  {"Ausgewählte Datei: " + selectedFile.name }
                </Typography>
               </Grid>
            }
            </Grid>
          <Grid item sm={6}>
            <Button color="primary" onClick={ () => setDateiBox(false)} fullWidth >{t("Schließen")}</Button>
          </Grid>
          
          <Grid item sm={6}>
            { selectedFile &&
              <Button color="primary" variant="contained" onClick={ () => dateiupload()} fullWidth>{t("Datei hochladen")}</Button>
            }
          </Grid>
      </Grid>
      </Box>
    </ResponsiveDialog>
    <InputBox
      open={openibox}
      handleResponse={inputBoxResult}
      fragen={fragen}
      title={iboxtitle}
      onClose={() => setOpenIBox(false)}
      buttonClick = {IboxButtonClick} 
      nurbuttons={nurbottons}       
     />
    { isLoading &&
      <FullPageSpinner/>
    }
    </Fragment>
 
  )
}
export default HRAufgabenglobal;
